import { render, staticRenderFns } from "./AddToCartDialog.vue?vue&type=template&id=fab7ba52"
import script from "./AddToCartDialog.ts?vue&type=script&lang=ts&external"
export * from "./AddToCartDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports